<template>
    <div class="row d-flex justify-content-center">
        <div class="col-12 d-flex flex-column justify-content-between">
            <div class="card shadow mt-2 my-md-0 p-3 bg-white rounded">

                <!-- Filtre adresse -->
                <!--<div class="row mb-2">
                    <div class="col-12 col-md-6">
                        <label class="form-label mb-1" for="addressFilter">Filtrer par adresse</label>
                        <input id="addressFilter" type="text" class="form-control" placeholder="Ex: Paris, Voltaire…"
                            v-model="addressQuery" @input="onAddressInput" />
                        <small class="text-muted" v-if="addressQuery && addressQuery.trim().length">
                            Recherche dans l'historique du véhicule (sans filtre date)
                        </small>
                    </div>
                    <div class="col-12 col-md-6 d-flex align-items-end justify-content-md-end mt-2 mt-md-0">
                        <button class="btn btn-outline-secondary" type="button"
                            :disabled="!addressQuery || !addressQuery.trim().length" @click="clearAddressFilter">
                            Effacer
                        </button>
                    </div>
                </div>-->

                <div class="d-flex justify-content-center">
                    <nav v-if="!(currentPage == 1 && lastPage)" aria-label="...">
                        <Pagination :lastPage="lastPage" :perPage="perPage" :currentPage="currentPage"
                            @pagechanged="onPageChange" />
                    </nav>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th v-if="this.displayCounter" scope="col" class="align-middle">Num</th>
                                <th scope="col" class="align-middle">Date</th>
                                <th scope="col" class="align-middle text-center">Réseau</th>
                                <th scope="col" class="align-middle">Vitesse</th>
                                <th scope="col" class="align-middle text-center">Direction</th>
                                <th scope="col" class="align-middle">Position</th>
                                <th scope="col" class="align-middle text-center">Alim</th>
                                <th scope="col" class="align-middle text-center">Batterie</th>
                                <th scope="col" class="align-middle text-center">Temp.<br>système</th>
                                <th scope="col" class="align-middle text-center">Sortie 1</th>
                                <th scope="col" class="align-middle text-center">Evènement</th>
                                <th scope="col" class="align-middle text-center">CAN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(balisePing, index) in balisePings" :key="balisePing.id || index">
                                <tr>
                                    <td v-if="this.displayCounter">{{ index + 1 + this.perPage * (this.currentPage - 1)
                                    }}
                                    </td>
                                    <td>
                                        <div v-if="balisePing && balisePing.date">
                                            {{ balisePing.date }}
                                        </div>
                                        <div v-else>
                                            _
                                        </div>

                                        <div v-if="$isAdmin && balisePing && balisePing.createdAt"
                                            class="small text-muted">
                                            {{ formatDate(balisePing.createdAt) }}
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="d-inline-flex align-items-center"><span
                                                class="small me-1">GSM:</span>
                                            <GSMDisplay :gsm="balisePing.levelGSM"></GSMDisplay>
                                        </div>
                                        <br>
                                        <div class="d-inline-flex align-items-center mt-2"><span
                                                class="small me-1">GPS:</span>
                                            <GPSDisplay :gps="balisePing.levelGPS"></GPSDisplay>
                                        </div>
                                    </td>
                                    <td v-if="balisePing" class="text-center"><small>{{ balisePing.speed }} Km/h</small>
                                    </td>
                                    <td v-if="balisePing && balisePing.direction" class="text-center"><span
                                            class="d-inline">{{ balisePing.direction }}°</span>
                                        <PositionDirection :position="balisePing" class="d-inline"></PositionDirection>
                                    </td>
                                    <td v-else class="text-center">_</td>
                                    <td v-if="balisePing && balisePing.latitude">
                                        <div><span>{{ balisePing.address }}</span></div>
                                        <div>
                                            <LatLongDisplay :latitude="balisePing.latitude"
                                                :longitude="balisePing.longitude"></LatLongDisplay>
                                        </div>
                                    </td>
                                    <td v-else>_</td>
                                    <td v-if="balisePing && balisePing.powerVoltage" class="text-center">
                                        <AlimDisplay :alim="balisePing.powerVoltage"></AlimDisplay>
                                    </td>
                                    <td v-else class="text-center">_</td>
                                    <td v-if="balisePing && balisePing.battery" class="text-center">
                                        <BatteryDisplay :battery="balisePing.battery" />
                                    </td>
                                    <td v-else class="text-center">_</td>
                                    <td v-if="balisePing && balisePing.temperature" class="text-center">
                                        <TemperatureDisplay :temperature="balisePing.temperature"></TemperatureDisplay>
                                    </td>
                                    <td v-else class="text-center">_</td>
                                    <!-- DOut1 / Sortie 1 -->
                                    <td v-if="balisePing && balisePing.dOut1 !== null && balisePing.dOut1 !== undefined"
                                        class="text-center">
                                        <small>{{ balisePing.dOut1 ? 'ON' : 'OFF' }}</small>
                                    </td>
                                    <td v-else class="text-center">_</td>
                                    <td v-if="balisePing && balisePing.alarms">
                                        <AlarmDisplay v-for="(alarm, index) in balisePing.alarms" :key="index"
                                            :alarm="alarm"></AlarmDisplay>
                                    </td>
                                    <td v-else>_</td>
                                    <td class="text-center align-middle">
                                        <button v-if="hasCanbusData(balisePing)" type="button" class="canbus-trigger"
                                            :class="{ active: expandedCanbusPositionId === balisePing.id }"
                                            @click="toggleCanbus(balisePing.id)">
                                            <span class="canbus-trigger-dot"></span>

                                            <span>CAN</span>

                                            <span class="canbus-trigger-count">
                                                {{ getCanbusDataCount(balisePing) }}
                                            </span>

                                            <span class="canbus-trigger-chevron"
                                                :class="{ open: expandedCanbusPositionId === balisePing.id }">
                                                ▾
                                            </span>
                                        </button>

                                        <span v-else class="text-muted">_</span>
                                    </td>
                                </tr>

                                <tr v-if="
                                    hasCanbusData(balisePing) &&
                                    expandedCanbusPositionId === balisePing.id
                                " class="canbus-detail-row">
                                    <td :colspan="displayCounter ? 12 : 11" class="canbus-detail-cell">
                                        <CanbusDataDisplay :canbusData="balisePing.canbusData" />
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div v-if="!(currentPage == 1 && lastPage)" class="d-flex justify-content-center my-2">
                    <div class="row col-12 col-md-6">
                        <div class="d-flex justify-content-start">
                            <div class="col-8"><label for="resPerPage">Résultats par page :</label></div>
                            <div class="col-3">
                                <select name="resPerPage" id="resPerPage" class="form-select" v-model="this.perPage"
                                    @change="this.currentPage = 1; onPageChange(this.currentPage)">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <nav v-if="!(currentPage == 1 && lastPage)" aria-label="...">
                        <Pagination :lastPage="lastPage" :perPage="perPage" :currentPage="currentPage"
                            @pagechanged="onPageChange" />
                    </nav>
                    <div v-if="pingsCount < 1">
                        <p>Aucunes données disponibles</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import PositionService from '@/services/position.service'
import FormatHelper from '@/helpers/format.helper.js'
import BatteryDisplay from './display/BatteryDisplay.vue'
import PositionDirection from "./display/PositionDirection.vue";
import GSMDisplay from './display/GSMDisplay.vue'
import GPSDisplay from './display/GPSDisplay.vue'
import LatLongDisplay from './display/LatLongDisplay.vue'
import AlimDisplay from './display/AlimDisplay.vue'
import TemperatureDisplay from './display/TemperatureDisplay.vue'
import AlarmDisplay from './display/AlarmDisplay.vue'
import Pagination from './PaginationComponent.vue'
import CanbusDataDisplay from './display/CanbusDataDisplay.vue'


export default {
    props: ['baliseId', 'givenStartDate', 'givenEndDate', 'order', 'displayCounter'],
    components: {
        BatteryDisplay,
        Pagination,
        GSMDisplay,
        AlimDisplay,
        PositionDirection,
        AlarmDisplay,
        GPSDisplay,
        LatLongDisplay,
        TemperatureDisplay,
        CanbusDataDisplay
    },
    data() {
        return {
            balisePings: [],
            pingsCount: null,
            pages: null,
            currentPage: 1,
            startResults: 0,
            perPage: 15,
            isEnd: false,
            displayEnd: false,
            startDate: null,
            endDate: null,
            lastPage: false,
            addressQuery: '',
            addressInputTimer: null,
            expandedCanbusPositionId: null,
        }
    },
    mounted() {
        if (this.givenStartDate) {
            this.startDate = this.givenStartDate
        }
        if (this.givenEndDate) {
            this.endDate = this.givenEndDate
        }
        this.balisePagesPings()
    },
    methods: {
        formatDate(date) {
            if (!date) return '_';

            return new Date(date).toLocaleString('fr-FR', {
                timeZone: 'Europe/Paris',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        },
        hasCanbusData(position) {
            const canbusData = position?.canbusData;

            if (!canbusData) {
                return false;
            }

            const ignoredFields = [
                "positionId",
                "createdAt",
                "updatedAt"
            ];

            return Object.entries(canbusData).some(
                ([key, value]) =>
                    !ignoredFields.includes(key) &&
                    value !== null &&
                    value !== undefined &&
                    value !== ""
            );
        },

        getCanbusDataCount(position) {
            const canbusData = position?.canbusData;

            if (!canbusData) {
                return 0;
            }

            const ignoredFields = [
                "positionId",
                "createdAt",
                "updatedAt"
            ];

            return Object.entries(canbusData).filter(
                ([key, value]) =>
                    !ignoredFields.includes(key) &&
                    value !== null &&
                    value !== undefined &&
                    value !== ""
            ).length;
        },

        toggleCanbus(positionId) {
            this.expandedCanbusPositionId =
                this.expandedCanbusPositionId === positionId
                    ? null
                    : positionId;
        },
        changeFilters(startDate, endDate) {
            this.startDate = startDate;
            this.endDate = endDate;
            this.balisePagesPings();
            this.currentPage = 1;
            this.onPageChange(this.currentPage)
        },
        onAddressInput() {
            // debounce léger pour éviter de spammer l'API
            if (this.addressInputTimer) clearTimeout(this.addressInputTimer);
            this.addressInputTimer = setTimeout(() => {
                this.currentPage = 1;
                this.startResults = 0;
                this.fetchPings();
            }, 400);
        },
        clearAddressFilter() {
            this.addressQuery = '';
            this.currentPage = 1;
            this.startResults = 0;
            this.fetchPings();
        },
        fetchPings() {
            this.balisePings = []

            const q = (this.addressQuery || '').trim();
            const limit = this.perPage + 1;
            const offset = this.startResults;

            const req = q.length
                ? PositionService.searchBalisePositionsByAddress(this.baliseId, q, offset, limit)
                : PositionService.getBalisePositions(
                    this.baliseId,
                    offset,
                    limit,
                    this.givenStartDate ? this.startDate : FormatHelper.dateFormatUTC(this.startDate),
                    this.givenEndDate ? this.endDate : FormatHelper.dateFormatUTC(this.endDate, true),
                    this.order
                );

            req.then(response => {
                this.pingsCount = response.data.length
                if (this.pingsCount == limit)
                    this.lastPage = false
                else
                    this.lastPage = true
                this.balisePings = FormatHelper.balisePingsFormat(this.lastPage ? response.data : response.data.slice(0, -1))
            })
        },
        balisePagesPings() {
            this.fetchPings()
        },
        onPageChange(page) {
            if (page > 1) {
                this.startResults = (page - 1) * this.perPage
            }
            else {
                this.startResults = 0
            }
            this.fetchPings()
            this.currentPage = page
        },
    }
}
</script>

<style scoped>
.canbus-trigger {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.28rem 0.5rem;
    color: #45546c;
    background: #f7f9fc;
    border: 1px solid #dbe2ec;
    border-radius: 6px;
    font-size: 0.72rem;
    font-weight: 650;
    line-height: 1;
    transition: 0.15s ease;
}

.canbus-trigger:hover,
.canbus-trigger.active {
    color: #2944b7;
    background: #eef2ff;
    border-color: #bfcaf7;
}

.canbus-trigger-dot {
    width: 6px;
    height: 6px;
    background: #4361ee;
    border-radius: 50%;
}

.canbus-trigger-count {
    min-width: 18px;
    padding: 0.16rem 0.3rem;
    color: #667085;
    background: #ffffff;
    border-radius: 10px;
    font-size: 0.67rem;
}

.canbus-trigger-chevron {
    margin-left: 0.1rem;
    transition: transform 0.15s ease;
}

.canbus-trigger-chevron.open {
    transform: rotate(180deg);
}

.canbus-detail-row>td {
    background: #ffffff !important;
}

.canbus-detail-cell {
    padding: 0 0.75rem !important;
    border-top: 0;
}
</style>